import "./App.css";
import HomePage from "./Pages/Home";

function App() {
	return <HomePage />;
}

export default App;
